var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON PHONE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.47723 2.27798C4.25095 2.75177 2 4.46064 2 5.51204C2 6.56344 2.88933 12.6802 4.99114 16.0687C7.09294 19.4571 11.338 22.417 12.3875 23.0798C13.437 23.7426 14.8925 24.0913 16.8342 22.8855C18.773 21.677 19.3392 20.08 18.8144 18.8742C18.2897 17.6657 15.9863 15.1344 15.0969 15.4857C14.2076 15.8371 12.3074 16.7314 11.9456 16.5371C11.5838 16.3428 7.86351 11.3573 7.86351 10.1089C7.86351 8.86056 11.2993 8.39475 10.5315 6.0577C9.76093 3.72066 8.10379 1.2665 5.47723 2.27798Z",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e1a054bcac19024e70be70f355942c53.svg";
export { ForwardRef as ReactComponent };